import styled from "styled-components";
import { Link } from "react-router-dom";
import { shop } from "../../../assets";
import AppWrapper from "../../../layout/AppWrapper";
import Title from "../../../utils/Title";
import BackButton from "../../BackButton";
import { useAuthContext } from "../../../context/auth_context";
import { useEffect } from "react";
import { useUserContext } from "../../../context/user_context";
import { formatDay } from "../../../utils/helpers";
import MiniLoader from "../../../utils/MIniLoader";
import { ICON_EXCLAMATION } from "../../../utils/icons";


function AllStoreReport() {

  const { btoken } = useUserContext();

  const {
    getStore: { getAllStore, allStores, storeLoad },
  } = useAuthContext();

  useEffect(() => {
    getAllStore(btoken);
  }, []);

  if (!allStores) {
    return (
      <AppWrapper
        pagename={"reports"}
      >
        <StyledAllStoreReport>
          <div className="d-flex gap-2">
            <Title title={"Store Report"} btnName={""} />
            <MiniLoader
              load={storeLoad}
            />
          </div>
          <BackButton />
          <div className="d-flex align-items-center justify-content-center my-5">
            <div className="text-center grey-text">
              <h1 className="text-md">
                {ICON_EXCLAMATION}
              </h1>
              <p className="">
                No Stores available...
              </p>
            </div>
          </div>
        </StyledAllStoreReport>
      </AppWrapper>
    );


  }


  return (
    <>
      <AppWrapper
        pagename={"reports"}
      >
        <StyledAllStoreReport>
          <div className="d-flex gap-2">
            <Title title={"Store Report"} btnName={""} />
            <MiniLoader
              load={storeLoad}
            />
          </div>
          <BackButton />

          <div className="justify-content-between row">

            {
              allStores?.map(({ storename, location, timestamp, token }) => <div className="mb-4 col-md-4"
                key={token}
              >
                <Link to={token}>
                  <div className="store-bg">
                    <h5 className="pry-text">
                      {storename}
                    </h5>
                    <p className="pry-text fw-bold">
                      Location: {location}
                    </p>
                    <p className="mb-5 small pry-text">
                      Date Created: {formatDay(timestamp)}
                    </p>
                  </div>
                </Link>
              </div>

              )
            }
          </div>


        </StyledAllStoreReport>



      </AppWrapper>

    </>
  );
}

export default AllStoreReport;

const StyledAllStoreReport = styled.div`


.store-bg {

   background-color: var(--light-color);
            background-image: url(${ shop });
            background-size: 250px;
            background-repeat:no-repeat;
            background-position: right;
            border-radius: 10px;
            padding: 4rem .5rem;
}
`;